import { request } from "@/api/request";

export async function getSiteSearch(query) {
  const list = await request({
    url: "/ac/site-search",
    method: "get",
    params: {
      q: query,
    },
  });
  return list;
}
